import React from 'react';
import LandingPage from './pages/LandingPage';

function App() {
  return <LandingPage data-testid='LandingPage' />;
}

export default App;
